<nb-card class="dialog-card">
    <nb-card-header
        >{{title}}
        <button nbButton ghost size="tiny" class="float-right ml-3" (click)="dialog.close(false)">
            <i class="fa fa-times"></i>
        </button>
    </nb-card-header>
    <nb-card-body *ngIf="content">
        <div class="d-flex flex-wrap dialog-content">{{content}}</div>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton [status]="confirmStatus" class="float-right ml-3" (click)="dialog.close(true)">
            {{confirmText}}
        </button>
        <button nbButton appearance="ghost" class="float-right" (click)="dialog.close(false)">{{cancelText}}</button>
    </nb-card-footer>
</nb-card>
